import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'
import { ventasRoutesMap } from './VentasRoutesMap'

const AppVentaRegistro = Loadable(lazy(() => import('./view/VentaRegistroV2')))
const AppVentaOfflineRegistro = Loadable(lazy(() => import('./view/VentaOfflineRegistro')))
const AppVentaGestion = Loadable(lazy(() => import('./view/VentaGestion')))
const AppVentaGestionOffline = Loadable(lazy(() => import('./view/VentaGestionOffline')))

const ventasRoutes = [
  {
    path: '/ventas/registro',
    element: <AppVentaRegistro />,
    auth: authRoles.admin,
  },
  {
    path: ventasRoutesMap.registroOffline.path,
    element: <AppVentaOfflineRegistro />,
    auth: authRoles.admin,
  },
  {
    path: '/ventas/gestion',
    element: <AppVentaGestion />,
    auth: authRoles.admin,
  },
  {
    path: ventasRoutesMap.gestionOffline.path,
    element: <AppVentaGestionOffline />,
    auth: authRoles.admin,
  },
]

export default ventasRoutes
